export function Shimmer({ className = "" }) {
    return (
      <div
        className={`bg-gray-700/40 rounded-md relative overflow-hidden ${className}`}
      >
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite]">
          <div className="w-1/2 h-full bg-gradient-to-r from-transparent via-gray-500/30 to-transparent" />
        </div>
      </div>
    );
  }
  